import React, { useState, useEffect } from 'react';
import { Typography, Grid, Button, Snackbar, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import InstituicaoCard from '../../components/Instituicoes/InstituicaoCard';
import { listarInstituicoes, excluirInstituicao } from '../../services/instituicaoService';

const ListaInstituicoesPage = () => {
  const [instituicoes, setInstituicoes] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    fetchInstituicoes();
  }, []);

  const fetchInstituicoes = async () => {
    try {
      const data = await listarInstituicoes();
      setInstituicoes(data);
    } catch (error) {
      console.error('Erro ao buscar instituições:', error);
      setSnackbar({ open: true, message: 'Erro ao carregar instituições', severity: 'error' });
    }
  };

  const handleDelete = async (id) => {
    try {
      await excluirInstituicao(id);
      setInstituicoes(instituicoes.filter(inst => inst.id !== id));
      setSnackbar({ open: true, message: 'Instituição excluída com sucesso', severity: 'success' });
    } catch (error) {
      console.error('Erro ao excluir instituição:', error);
      setSnackbar({ open: true, message: 'Erro ao excluir instituição', severity: 'error' });
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Instituições
      </Typography>
      <Button
        component={Link}
        to="/instituicoes/criar"
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
      >
        Adicionar Nova Instituição
      </Button>
      <Grid container spacing={3}>
        {instituicoes.map((instituicao) => (
          <Grid item key={instituicao.id} xs={12} sm={6} md={4}>
            <InstituicaoCard 
              instituicao={instituicao} 
              onDelete={() => handleDelete(instituicao.id)}
            />
          </Grid>
        ))}
      </Grid>
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ListaInstituicoesPage;